import React, { Component } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import * as diff from 'object-diff';

import { Form, Field, PasswordStrength, Authenticate } from './Form/Form.js';

class UpdateInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialValues: {
        currentPassword: "",
        firstName: "",
        lastName: "",
        email: "",
        newPassword: "",
        newPasswordConfirm: "",
      },
      loading: true
    }
  }

  componentDidMount = () => {
    this.getUserInfo();
  }

  getUserInfo = () => {
    fetch('/api/getUserInfo', {
      method: "GET",
      credentials: "same-origin"
    }).then((res) => {
      if(!res.ok){
        if(res.status === 401) alert("unauthorised");
        else{
          alert("An error occured");
          throw Error(res.statusText);
        }
      }
      return res;
    })
    .then((res) => res.json())
    .then((body) => {
      let initialValues = this.state.initialValues;
      initialValues.firstName = body.cn;
      initialValues.lastName = body.sn;
      initialValues.email = body.email;

      this.setState({initialValues: initialValues});
    })
    .catch(function(error) {
      console.log(error);
    })
    .then(() => this.setState({loading: false}));
  }

  changeView = (newView) => {
    this.props.changeView(newView);
  }

  postInfo = (values, actions) => {
    fetch('/api/updateUserInfo', {
      method: "POST",
      body: JSON.stringify(diff(this.state.initialValues, values)),
      headers: {
        "Content-Type": "application/json"
      },
      credentials: "same-origin"
    })
    .then((res) => {
      if(!res.ok){
        if (res.status === 401) {
          alert("Entered Incorrect password");
        } else if (res.status === 400) {
          res.json().then(errors => actions.setErrors(errors));
        } else {
          alert("Could not update info");
          console.log(res.statusText);
        }
      } else {
        alert("Info Updated Successfully");
        this.changeView("sites");
      }
    })
    .then(() => {
      actions.setFieldValue('currentPassword', '', false);
      actions.setSubmitting(false)
    });

    return;
  }

  validationSchema = () => {
    return Yup.object()
      .shape({
        currentPassword: Yup.string().ensure().required("Required!")
          .max(128, "Too long!"),
        firstName: Yup.string().ensure()
          .required('Required!')
          .min(2, 'Too short!')
          .max(30, 'Too long!')
          .matches(/^[a-zA-Z]+(-[a-zA-Z]+)?$/, "Please enter a valid first name!"),
        lastName: Yup.string().ensure()
          .required('Required!')
          .min(2, 'Too short!')
          .max(30, 'Too long!')
          .matches(/^[a-zA-Z]+(-[a-zA-Z]+)?$/, "Please enter a valid last name!"),
        email: Yup.string().ensure()
          .required('Required!')
          .email("Please enter a valid email!"),
        newPassword: Yup.string()
          .min(8, "Too short!")
          .max(128, "Too long!"),
        newPasswordConfirm: Yup.string()
          .when("newPassword", {
            is: (value) => value,
            then: Yup.string().required("Required!").oneOf([Yup.ref("newPassword")], "Passwords do not match")
          })
      })
  }

  render = () => {
    return (
      <Formik initialValues={this.state.initialValues} onSubmit={this.postInfo} validationSchema={this.validationSchema()}>
        {
          ({values, touched, errors, dirty, isValid, isSubmitting, handleChange, handleBlur, handleSubmit, handleReset, status}) => {
            const propsForField = {values, touched, errors, handleChange, handleBlur, dirty, status};
            return (
              <Form title="Update Details" onSubmit={handleSubmit} isLoading={isSubmitting || this.state.loading}>
                <Field id="firstName" fieldName="First Name" {...propsForField} />
                <Field id="lastName" fieldName="Last Name" {...propsForField} />
                <Field id="email" type="email" fieldName="Email" {...propsForField} />

                <hr style={{margin: "40px 0px", marginLeft: "20px"}} />

                <Field id="newPassword" type="password" fieldName="New Password" {...propsForField} />
                <Field id="newPasswordConfirm" type="password" fieldName="Confirm New Password" {...propsForField} />

                <PasswordStrength password={values.newPassword} />

                <Authenticate id="currentPassword" initialValues={this.state.initialValues} {...propsForField} />

                <div className="form-group">
                  <label className="col-md-4 control-label"></label>
                  <div className="col-md-4">
                    <button type="submit" className="btn btn-primary" disabled={!dirty}>Update</button>
                  </div>
                  <div className="col-md-4">
                    <button type="button" className="btn btn-light" onClick={() => this.changeView("sites")}>Cancel</button>
                  </div>
                </div>
              </Form>
            );
          }
        }
      </Formik>
    )
  }
}

export default UpdateInfo;



// WEBPACK FOOTER //
// ./src/Components/UpdateInfo.js